import { css } from '@emotion/react';

import { TypographyStyles } from 'src/common/ui/base';

export const dialogTitleCss = css`
  ${TypographyStyles.headline2};
  margin-bottom: 0;
  text-transform: none;
`;

export const dialogContentCss = css`
  ${TypographyStyles.body1};
`;

export const dialogActionsCss = css`
  padding: 20px 24px;

  .MuiDialogTitle-root + &,
  .MuiDialogContent-root + & {
    padding-top: 0;
  }
`;
